<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Edycja rodzaju wysyłki
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            :value="transportTaskPropertyValue"
                            :items="deliveryMethods"
                            item-value="name"
                            item-text="name"
                            label="Transport"
                            outlined
                            dense
                            clearable
                            hide-details
                            @change="changeTransportTaskPropertyValue"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            :value="distance"
                            label="Dystans"
                            suffix="km"
                            outlined
                            dense
                            hide-details
                            @input="handleDistance"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-btn
                            color="success"
                            data-sentry-label="Oblicz"
                            :disabled="isCalculateDeliveryCostDisabled"
                            @click="calculateDeliveryCost"
                        >
                            Oblicz koszt wysyłki
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            :value="transportCost"
                            label="Koszt"
                            suffix="zł"
                            outlined
                            dense
                            :hide-details="!transportCostError"
                            :error="!!transportCostError"
                            :hint="transportCostError"
                            @input="handleCost"
                            @change="transportCostChange"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    :disabled="isSaveDisabled"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mask } from 'vue-the-mask'
import parse from '@/mixins/parse'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'SendingParametersDialog',
    directives: { mask },
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        taskData: {
            type: Object,
            default: null
        },
        impositionPackages: {
            type: Array,
            default: () => []
        },
        totalDeliveryWeight: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            task: {},
            factor: null,
            kilometers: null,
            deliveryMethods: null
        }
    },
    computed: {
        transportTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 10)
        },
        transportTaskPropertyItems() {
            if (this.transportTaskProperty) {
                return this.transportTaskProperty.productionProcessProperty.productionProcessPropertyValues
            }

            return []
        },
        transportTaskPropertyValue() {
            return this.transportTaskProperty ? this.transportTaskProperty.value : null
        },
        transportDistanceTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 26)
        },
        transportCostTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 20)
        },
        distance() {
            return this.transportDistanceTaskProperty ? this.transportDistanceTaskProperty.value : ''
        },
        transportCost() {
            return this.transportCostTaskProperty ? this.transportCostTaskProperty.value : ''
        },
        isCalculateDeliveryCostDisabled() {
            return !this.transportTaskProperty?.value || this.transportDistanceTaskProperty?.value === '' || this.transportDistanceTaskProperty?.value === null
        },
        transportCostError() {
            const regex = /^\d*(\.\d{0,2})?$/
            const value = this.transportCost

            if (value === null || value === '' || value === undefined) {
                return ''
            }
            if (!regex.test(value.toString())) {
                return 'Maksymalnie 2 cyfry po przecinku'
            }

            return ''
        },
        isSaveDisabled() {
            return !!this.transportCostError || !this.transportTaskProperty?.value
        },

    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.task = JSON.parse(JSON.stringify(this.taskData))
            } else {
                setTimeout(() => {
                    this.task = {}
                }, 500)
            }
        }
    },
    mounted() {
        this.getDeliveryMethods()
    },
    methods: {
        setDistanceValue() {
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 26).value = '-'
        },
        changeTransportTaskPropertyValue(value) {
            this.transportTaskProperty.value = value
            this.clearTransportDistanceTaskProperty()
            this.clearTransportCostTaskProperty()
        },
        clearTransportDistanceTaskProperty() {
            this.transportDistanceTaskProperty.value = ''
        },
        clearTransportCostTaskProperty() {
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 20).value = ''
        },
        setTransportCostTaskPropertyValue() {
            const cost = this.calculateCost(this.kilometers, this.factor)

            this.handleCost(cost)
        },
        calculateCost(distance, factor) {
            return Math.ceil(parseInt(distance) * factor).toString()

        },
        handleDistance(value) {
            value = value ? value : ''
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 26).value = value
            this.kilometers = value
        },
        handleCost(value) {
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 20).value = value
        },
        transportCostChange() {
            this.handleCost(parseFloat(this.transportCost) || 0)
        },
        onSave() {
            this.$emit('on-save', this.task)
        },
        onClose() {
            this.$emit('on-close')
        },
        async getDeliveryMethods() {
            const query = '?isAvailableInTransportSelection=true'

            return await this.$store.dispatch('calculations/getDeliveryMethods', { query })
                .then(response => {
                    this.deliveryMethods = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        async calculateDeliveryCost() {
            const deliveryMethodData = this.deliveryMethods.find(item => item.name === this.transportTaskProperty.value)
            const payload = {
                deliveryMethodId: deliveryMethodData.id,
                distance: parseInt(this.distance),
                weight: this.totalDeliveryWeight,
                packagesQuantities: this.impositionPackages.map(item => ({
                    packageTypeId: item.packageType,
                    quantity: item.packageAmount,
                })),
            }

            return await this.$store.dispatch('calculations/calculateDeliveryCost', payload)
                .then(response => {
                    this.handleCost(response.data.price)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>